import { Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { ExtraDataApiModel } from '@era/inroom-sdk';

import { selectCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';
import { RoomExtraDataUpdated } from '../../../stores/rooms/rooms.actions';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';
import { SetRoomConfiguration } from '../room-configuration-store/room-configuration.actions';
import { RoomConfiguration } from '../room-configuration-store/room-configuration.reducer';
import { selectCurrentRoomConfiguration } from '../room-configuration-store/room-configuration.selector';
import { GuestInfoComponent } from './guest-info.component';

@Component({
  selector: 'era-guest-info',
  templateUrl: './guest-info.container.html',
  imports: [GuestInfoComponent],
})
export class GuestInfoContainerComponent {
  private readonly store = inject(Store);

  public readonly room = this.store.selectSignal(selectCurrentRoom);
  public readonly roomConfiguration = this.store.selectSignal(selectCurrentRoomConfiguration);
  public readonly reservation = this.store.selectSignal(selectCurrentMobileReservation);

  onExtraDataChange(data: ExtraDataApiModel) {
    const room = this.room();

    const roomExtraDataUpdated = new RoomExtraDataUpdated({
      hotelCode: room?.HotelCode ?? '',
      unitCode: room?.Room ?? '',
      data,
    });

    this.store.dispatch(roomExtraDataUpdated);
  }

  onRoomConfigurationChange(data: RoomConfiguration) {
    this.store.dispatch(new SetRoomConfiguration(data));
  }
}
